import { User } from "firebase/auth";
import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { setUserAnalyticsContext } from "../service/analytics";

interface AuthState {
  profile: User | {};
  setUser: (user: User | {}) => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      profile: {},
      setUser: async (user: User | {}) => {
        setUserAnalyticsContext(user);
        set((state) => ({
          ...state,
          profile: user,
        }));
      },
    }),
    {
      name: "profile-storage",
      storage: createJSONStorage(() => localStorage),
    }
  )
);

